import { Injectable } from "@angular/core";
import { FormSearchParametersModel } from "apps-module/app/entry-modules/charity-search/models/form-search-parameters.model";
import { QuerySearchParametersModel } from "apps-module/app/entry-modules/charity-search/models/query-search-parameters.model";
import { BrowserWindowService } from "apps-module/app/shared-library/services/environment/browser-window.service";
import { QueryStringSerializationService } from "apps-module/app/shared-library/services/environment/query-string-serialization.service";

@Injectable()
export class QuerySearchParametersService {

    public constructor(
        private readonly _serializationService: QueryStringSerializationService,
        private readonly _browserWindowService: BrowserWindowService
    ) {
    }

    public set(searchParameters: FormSearchParametersModel): void {
        const queryParams = {
            pageNumber: searchParameters.pageNumber,
            aooa: searchParameters.aooa,
            aoob: searchParameters.aoob,
            aood: searchParameters.aood,
            classification1: searchParameters.classification1,
            classification2: searchParameters.classification2,
            classification3: searchParameters.classification3,
            income: searchParameters.income,
            site: searchParameters.site,
            include: searchParameters.include,
            orgType: searchParameters.orgType,
            searchText: searchParameters.searchText,
            sortOption: searchParameters.sortOption
        } as QuerySearchParametersModel;

        const queryString = this._serializationService.serialize(queryParams);

        this._browserWindowService.setQueryString(queryString);
    }
}
